Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.InstagramDMContent
  @ORIGIN = 'instagram-dm-api'

  constructor: (data) ->
    @data = data
    @origin = Monitoring.Models.SocialContents.InstagramDMContent.ORIGIN

  getJson: ->
    @data

  getGroupType: ->
    'instagram_private'

  getType: ->
    'instagram'

  getSubType: ->
    'ig-message'

  getPrivacy: ->
    'private'

  getContentId: ->
    @data.content?.id

  isBrandContent: ->
    @data.content?.from_brand

  hasUser: ->
    true

  hasProfile: ->
    true

  hasRelated: ->
    true

  getAuthorId: ->
    @data.author?.id

  getAuthorName: ->
    @data.author?.name

  getAuthorUsername: ->
    @data.author?.username

  getAvatar: ->
    @data.author?.profile_pic_url

  getCreatedAt: ->
    Date.create @data.content?.created_at

  hasAttachments: ->
    false

  getAttachments: ->
    []

  hasShares: ->
    false

  getOrigin: ->
    @origin
